/* global axios */
import ApiClient from './ApiClient';

class UazapiAPI extends ApiClient {
  constructor() {
    super('uazapi', { accountScoped: true });
  }

  getStatus(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/status`
    );
  }

  getSettings(accountId, inboxId) {
    return axios.get(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/settings`
    );
  }

  connect(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/connect`
    );
  }

  reconnect(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/reconnect`
    );
  }

  disconnect(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/disconnect`
    );
  }

  requestPairingCode(accountId, inboxId, phoneNumber) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/request_pairing_code`,
      { phone_number: phoneNumber }
    );
  }

  updateSettings(accountId, inboxId, settings) {
    return axios.patch(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/settings`,
      { settings }
    );
  }

  reconfigureChatwoot(accountId, inboxId) {
    return axios.post(
      `${this.apiVersion}/accounts/${accountId}/uazapi/${inboxId}/reconfigure_chatwoot`
    );
  }
}

export default new UazapiAPI();
